import React, { useEffect, useState } from 'react';
import { Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { documentsDropDownAction } from '../../redux/actions/translationAction';
import errorToast from '../../components/toasts/errorToast';
import { useDispatch } from 'react-redux';
import ReactSelectFiled from '../../components/forms/reactSelect';
import pdfIcon from "../../assets/icons/pdf-icon.svg";
import pptxIcon from "../../assets/icons/pptx-icon.svg";
import docxIcon from "../../assets/icons/docx-icon.svg";
import htmlIcon from "../../assets/icons/html-icon.webp";
import { useAuth } from '../../context/AuthContext';

const NewTranslation = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [documentOptions, setDocumentOptions] = useState([]);
    const [Loading, setLoading] = useState(false)
    const { isAdmin, isTeamLead } = useAuth();

    useEffect(() => {
        setLoading(true)
        dispatch(documentsDropDownAction({}, onSuccess, onError));
    }, []);

    const onSuccess = (data) => {
        const documentData = data.data.data.map(document => ({
            label: document.name,
            value: document.id,
            document: document
        }));
        setDocumentOptions(documentData);
        setLoading(false)
    };
    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    if (!isAdmin || isTeamLead) {
        return (
            <div className="w-100 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                <i className="bi bi-shield-lock fs_40 text-danger mb-3"></i>
                <h5 className="fw_600">Access Denied</h5>
                <p className="text-muted fs_14">This page is only accessible to company administrators and team leads.</p>
            </div>
        );
    }

    return (
        <div className="d-flex vh-90">
            <div className="w-100">
                <div className="w-100 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2">
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">Translation</h2>
                </div>
                <div style={{ height: "91vh" }} className="d-flex align-items-center justify-content-center">
                    <div>
                        <div className="d-flex docoment_type_images mb-4 justify-content-center align-items-center">
                            <Image
                                alt="pptx"
                                // src="https://www.gstatic.com/translation_hub/images/pptx-icon.svg"
                                src={pptxIcon}
                                width={60}
                                height={70}
                                className="docoment_type_logo"
                            />
                            <Image
                                alt="pdf"
                                // src="https://www.gstatic.com/translation_hub/images/pdf-icon.svg"
                                src={pdfIcon}
                                width={60}
                                height={70}
                                className="docoment_type_logo"
                            />
                            <Image
                                alt="docx"
                                // src="https://www.gstatic.com/translation_hub/images/docx-icon.svg"
                                src={docxIcon}
                                width={60}
                                height={70}
                                className="docoment_type_logo"
                            />
                            <Image
                                alt="html"
                                // src="https://www.gstatic.com/translation_hub/images/docx-icon.svg"
                                src={htmlIcon}
                                width={60}
                                height={70}
                                className="docoment_type_logo"
                            />
                        </div>
                        <div className="d-flex position-relative">

                            <div style={{ width: '20em' }}>
                                <ReactSelectFiled
                                    name="document"
                                    noDataMessage='No Documents'
                                    options={documentOptions}
                                    onChange={(value, option) => {
                                        console.log(value, "selected document", option);
                                        navigate('/translation-page', { state: { selctedDocumentId: value, documentData: option } });
                                    }}
                                    isLoading={Loading}

                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewTranslation;



